import { gql } from "@apollo/client";

export const TICKET_POOL_FRAGMENT = gql`
  fragment TicketPool on TicketPool {
    id
    name
    quantity
    price
    priceWithFees
    hasAnyTicketSold
    venueFee
    maxTicketsPerOrder
    minTicketsPerOrder
    availableBeforeDays
    availableBeforeTime
    expireBeforeDays
    expireBeforeTime
    description
    eventId
    ticketTemplateId
    isAutoApprove
    isScannerOnly
    createdAt
    updatedAt
  }
`;
